import { useMemo } from 'react';
import { useDelayedState } from '../../utils/hooks/useDelayedState';
import {
  AUTOSAVE_REVERT_DELAY_KEY,
  AUTOSAVE_SUCCESS_DELAY_KEY,
  TIME_TOKENS,
} from '../../utils/timeTokens';

export type AutosaveStatus = 'idle' | 'pending' | 'success' | 'reverted';

const getSuccessDelay = () => TIME_TOKENS[AUTOSAVE_SUCCESS_DELAY_KEY];
const getRevertDelay = () => TIME_TOKENS[AUTOSAVE_REVERT_DELAY_KEY];

export const useAutosaveStatus = () => {
  const [status, setStatusWithDelay] = useDelayedState<AutosaveStatus>('idle');

  return {
    status,
    statusHandlers: useMemo(
      () => ({
        savingStarted: () => {
          setStatusWithDelay('pending');
        },
        savingSucceeded: () => {
          setStatusWithDelay('success');
          setStatusWithDelay('idle', getSuccessDelay());
        },
        savingFailed: () => {
          setStatusWithDelay('idle');
        },
        undoStarted: () => {
          setStatusWithDelay('reverted');
          setStatusWithDelay('idle', getRevertDelay());
        },
        requestsCleared: () => {
          setStatusWithDelay('idle');
        },
      }),
      [setStatusWithDelay]
    ),
  };
};
